import { Injectable } from '@angular/core';
import { Subject  }    from 'rxjs';

@Injectable()
export class TenantChangeService {

  // Observable string sources
  private tenantName = new Subject<string>();

  // Observable string streams
  tenantName$ = this.tenantName.asObservable();

  // Service message commands
  notify(tenantName: string) {
    this.tenantName.next(tenantName);
  }
}